import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-register-footer',
  templateUrl: './register-footer.component.html',
  styleUrls: ['./register-footer.component.scss'],
  standalone: false,
})
export class RegisterFooterComponent {
  @Input() step: number = 0;
  @Input() buttonText: string = 'BUTTONS.CONTINUE';
  @Output() continueClicked = new EventEmitter<number>();

  constructor() {}

  onContinueClick() {
    this.continueClicked.emit(this.step + 1);
  }
} 